import { render, staticRenderFns } from "./QuestionsHistory.vue?vue&type=template&id=415dbb1c"
import script from "./QuestionsHistory.vue?vue&type=script&lang=js"
export * from "./QuestionsHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports